/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ControlHyperlink } from './ControlHyperlink';
import {
    ControlHyperlinkFromJSON,
    ControlHyperlinkFromJSONTyped,
    ControlHyperlinkToJSON,
} from './ControlHyperlink';

/**
 * 
 * @export
 * @interface ControlCreateZeroDayAlertRequest
 */
export interface ControlCreateZeroDayAlertRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    vendor_name: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    cve?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    short_risk_description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    long_risk_description: string;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    how_to_resolve: string;
    /**
     * 
     * @type {Array<ControlHyperlink>}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    references: Array<ControlHyperlink>;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    active: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    escalated?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ControlCreateZeroDayAlertRequest
     */
    first_detected_date?: string;
}

/**
 * Check if a given object implements the ControlCreateZeroDayAlertRequest interface.
 */
export function instanceOfControlCreateZeroDayAlertRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "vendor_name" in value;
    isInstance = isInstance && "short_risk_description" in value;
    isInstance = isInstance && "long_risk_description" in value;
    isInstance = isInstance && "how_to_resolve" in value;
    isInstance = isInstance && "references" in value;
    isInstance = isInstance && "active" in value;

    return isInstance;
}

export function ControlCreateZeroDayAlertRequestFromJSON(json: any): ControlCreateZeroDayAlertRequest {
    return ControlCreateZeroDayAlertRequestFromJSONTyped(json, false);
}

export function ControlCreateZeroDayAlertRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlCreateZeroDayAlertRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'title': json['title'],
        'vendor_name': json['vendor_name'],
        'cve': !exists(json, 'cve') ? undefined : json['cve'],
        'short_risk_description': json['short_risk_description'],
        'long_risk_description': json['long_risk_description'],
        'how_to_resolve': json['how_to_resolve'],
        'references': ((json['references'] as Array<any>).map(ControlHyperlinkFromJSON)),
        'active': json['active'],
        'escalated': !exists(json, 'escalated') ? undefined : json['escalated'],
        'first_detected_date': !exists(json, 'first_detected_date') ? undefined : json['first_detected_date'],
    };
}

export function ControlCreateZeroDayAlertRequestToJSON(value?: ControlCreateZeroDayAlertRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'title': value.title,
        'vendor_name': value.vendor_name,
        'cve': value.cve,
        'short_risk_description': value.short_risk_description,
        'long_risk_description': value.long_risk_description,
        'how_to_resolve': value.how_to_resolve,
        'references': ((value.references as Array<any>).map(ControlHyperlinkToJSON)),
        'active': value.active,
        'escalated': value.escalated,
        'first_detected_date': value.first_detected_date,
    };
}

